import { apiClient } from './client'
import type { RiskLevel } from '@/types'

const VALID_LEVELS: RiskLevel[] = ['safe', 'balanced', 'agile']

/**
 * Store-level default decision posture (RISK-LEVELS-COPY.md).
 * GET/POST /api/stores/{store_id}/risk-config — a single `default_risk_level` attribute on the
 * store row (same pattern as ga4-config). Create-experiment pre-selects this default.
 */
export class RiskService {
  /** Returns the store default; falls back to 'balanced' (the recommended stop) on any failure. */
  async getConfig(storeId: string): Promise<RiskLevel> {
    try {
      const response = await apiClient.get<{ success: boolean; data: any }>(
        `/api/stores/${storeId}/risk-config`
      )
      const level = response.data?.default_risk_level
      return VALID_LEVELS.includes(level) ? level : 'balanced'
    } catch (error) {
      console.warn('Failed to load risk config, defaulting to balanced:', error)
      return 'balanced'
    }
  }

  async saveConfig(storeId: string, level: RiskLevel): Promise<boolean> {
    try {
      const response = await apiClient.post<{ success: boolean; data: any }>(
        `/api/stores/${storeId}/risk-config`,
        { default_risk_level: level }
      )
      return response.success === true
    } catch (error) {
      console.error('Failed to save risk config:', error)
      return false
    }
  }
}

export const riskService = new RiskService()
